<template>
  <button
    :class="
      `ml-4 box-border h-10 bg-white border-4 border-${color} disabled:opacity-50 disabled:bg-black`
    "
    type="button"
    :disabled="type===0"
    @click="submitProfile()"
  >
    <div class="flex flex-row items-center justify-center">
      <ApprovedIcn width="20px" height="20px" class="mr-1" />
      <div class="flex flex-row items-baseline">
        <span :class="`text-${color} text-lg font-bold leading-tight`">
          登録
        </span>
        <span :class="`text-${color} text-sm font-bold leading-tight`"
          >する</span
        >
      </div>
    </div>
  </button>
</template>

<script>
import ApprovedIcn from '@/assets/icons/approved-green.svg?inline'

export default {
  name: 'AppSetProfileBtn',

  components: {
    ApprovedIcn,
  },

  props: {
    color: String,
    type: Number,
  },

  setup(props, context) {
    const submitProfile = () => {
      if (props.type == 0) {
        context.emit("click","profile")
      }
      if (props.type == 2) {
        context.emit("click","changePass")
      }
    }
    return { submitProfile }
  },
}
</script>

<style lang="scss" scoped>
svg {
  circle {
    fill: white;
  }
}

button {
  border-radius: 20px;
  width: 512px;
  &:disabled {
    div {
      svg {
        circle {
          fill: black;
        }
      }
    }
  }
}
</style>
